import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import HerosectionHeader from '../../Componet/Herosection/HerosectionHeader';
import { findBlogBySlug, getBlogTitle } from '../../utils/blog';


function BlogSingle() {
    const { slug } = useParams();
    const location = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    let blog = useSelector((state) => state.blog.selectedBlog);
    const blogs = useSelector((state) => state.blog.blogItems);
    const selectedBlog = slug
        ? findBlogBySlug(blogs, slug)
        : blogs.find((item) => item.id === blog) || blogs[0];

    useEffect(() => {
        const blogTitle = getBlogTitle(selectedBlog, location.pathname);
        if (blogTitle) {
            document.title = `${blogTitle} | EpicFinal`;
        }
    }, [location.pathname, selectedBlog]);

    if (slug && !selectedBlog) {
        return <Navigate to={window.location.pathname.startsWith('/he') ? "/he/blog_card" : "/blog_card"} replace />;
    }

    return (
        <>
            <HerosectionHeader folder1={"pages"} folder2={"Blog"} name={"Tech Doc"} />

            <section>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            {selectedBlog &&
                                <div className="card border-0 bg-transparent">
                                    <img className="card-img-top shadow" src={require(`../../assets/images/blog/${selectedBlog.image.split('/')[3]}`)} alt="Image1" />
                                    <div className="card-body pt-5 px-0">
                                        <div>
                                            <div className="d-inline-block bg-light text-center px-2 py-1 rounded me-2">{selectedBlog.date}</div> <div className="d-inline-block btn-link">{selectedBlog.category}</div>
                                        </div>
                                        <h2 className="h5 my-4">
                                            <div className="link-title" dir="auto" style={{ unicodeBidi: 'plaintext' }}>{getBlogTitle(selectedBlog, location.pathname)}</div>
                                        </h2>
                                        <div className="blog-content" dangerouslySetInnerHTML={{ __html: selectedBlog.content }} />
                                    </div>   <blockquote className="card bg-primary border-0 p-5 mt-5 text-white">"Love your neighbor as yourself." <span className="mt-2 fst-italic font-w-6">- Matthew 22:39</span>
                                    </blockquote>
                                    <div className="d-md-flex justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <h6 className="mb-0 me-4">Share It:</h6>
                                            <ul className="list-inline mb-0">
                                                <li className="list-inline-item"><a className="border rounded px-2 py-1 text-dark" href="/"><i className="la la-facebook" /></a>
                                                </li>
                                                <li className="list-inline-item"><a className="border rounded px-2 py-1 text-dark" href="/"><i className="la la-dribbble" /></a>
                                                </li>
                                                <li className="list-inline-item"><a className="border rounded px-2 py-1 text-dark" href="/"><i className="la la-instagram" /></a>
                                                </li>
                                                <li className="list-inline-item"><a className="border rounded px-2 py-1 text-dark" href="/"><i className="la la-twitter" /></a>
                                                </li>
                                                <li className="list-inline-item"><a className="border rounded px-2 py-1 text-dark" href="/"><i className="la la-linkedin" /></a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="d-flex align-items-center text-md-end mt-5 mt-md-0">
                                            <h6 className="mb-0 me-4">Tags: </h6>
                                            <ul className="list-inline mb-0">
                                                <li className="list-inline-item"><a className="btn-link rounded d-inline-block p-2 bg-light m-1" href="/">StartUP</a>
                                                </li>
                                                <li className="list-inline-item"><a className="btn-link rounded d-inline-block p-2 bg-light m-1" href="/">Enterprise</a>
                                                </li>
                                                <li className="list-inline-item"><a className="btn-link rounded d-inline-block p-2 bg-light m-1" href="/">Collaboration</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    {/* <div className="mt-6 shadow p-5">
                                        <div className="mb-4">
                                            <h2>All Comments</h2>
                                        </div>
                                        <div className="row">
                                            <div className="mb-4 mb-md-0 col-md-auto">
                                                <img className="img-fluid rounded shadow" alt="image1" src={require("../../assets/images/thumbnail/01.jpg")} />
                                            </div>
                                            <div className="col-md">
                                                <div className="d-flex justify-content-between align-items-center border-bottom pb-3 mb-3">
                                                    <h6 className="mb-0">Raymond Lee</h6>  <small className="text-muted">5 Days Ago</small>
                                                </div>
                                                <p>Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. A small river named. Primis veritus contentiones nec ad, nec et tantas semper delicatissimi.</p> <a className="btn btn-primary btn-sm" href="/">Reply</a>
                                            </div>
                                        </div>
                                        <div className="row border p-4 my-5 rounded">
                                            <div className="mb-4 mb-md-0 col-md-auto">
                                                <img className="img-fluid rounded shadow" alt="image2" src={require("../../assets/images/thumbnail/02.jpg")} />
                                            </div>
                                            <div className="col-md">
                                                <div className="d-flex justify-content-between align-items-center border-bottom pb-3 mb-3">
                                                    <h6 className="mb-0">Dani Karie</h6>  <small className="text-muted">5 Days Ago</small>
                                                </div>
                                                <p>Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. A small river named. Primis veritus contentiones nec ad, nec et tantas semper delicatissimi.</p> <a className="btn btn-primary btn-sm" href="/">Reply</a>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="mb-4 mb-md-0 col-md-auto">
                                                <img className="img-fluid rounded shadow" alt="image3" src={require("../../assets/images/thumbnail/03.jpg")} />
                                            </div>
                                            <div className="col-md">
                                                <div className="d-flex justify-content-between align-items-center border-bottom pb-3 mb-3">
                                                    <h6 className="mb-0">Karlo Bond</h6>  <small className="text-muted">5 Days Ago</small>
                                                </div>
                                                <p>Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. A small river named. Primis veritus contentiones nec ad, nec et tantas semper delicatissimi.</p> <a className="btn btn-primary btn-sm" href="/">Reply</a>
                                            </div>
                                        </div>
                                    </div> */}
                                    {/* <div className="post-comments mt-5">
                                        <div className="mb-4">
                                            <h2>Leave A Comment</h2>
                                        </div>
                                        <Form2 />
                                    </div> */}
                                    <div />
                                </div>}

                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default BlogSingle
